<template>
  <div class="icon-loading">
    <svg
      width="30px"
      height="30px"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >

      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="none"
      />

      <circle
        cx="50"
        cy="50"
        r="40"
        stroke="none"
        fill="none"
        stroke-width="10"
        stroke-linecap="round"
      />

      <circle
        class="icon-loading__circle"
        cx="50"
        cy="50"
        r="40"
        stroke="#535CF9"
        fill="none"
        stroke-width="6"
        stroke-linecap="round"
      />

    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconLoading'
};
</script>

<style lang="scss" src="@/assets/icons/icon-loading-view.scss"></style>



// WEBPACK FOOTER //
// icon-loading-view.vue